<template>
    <div id="funcionario-editar">
        <section id="content">
            <!--start container-->
            <div class="container">
                <div class="row">
                    <TituloPagina titulo="Editar categoria" />
                    <div class="col s12 m12 l12">
                        <div class="card-panel">
                            <!-- <h4 class="header">Editar de categoria</h4> -->
                            <div class="row">
                                <form
                                    class="col s12"
                                    v-on:submit.prevent="save"
                                >
                                    <formulario-categoria
                                        v-if="showForm"
                                        @newdata="handleDataCategoria($event)"
                                        :categoria="formData"
                                    ></formulario-categoria>
                                    <div class="row">
                                        <div class="input-field col s12">
                                            <button
                                                class="btn btn-default waves-effect waves-light right"
                                                type="submit"
                                                name="action"
                                            >
                                                Salvar
                                                <!-- <i class="material-icons right">send</i> -->
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--end container-->
        </section>
    </div>
</template>

<script>
import { get, put } from "@/helpers/api";
import FormularioCategoria from "./Formulario";
import Message from "@/helpers/message";
import TituloPagina from "@/components/common/TituloPagina";
import { DONO, GERENTE, ESPECIALISTA, MASTER } from "@/constants/funcionarioCargo.js";
import Auth from "@/store/auth";

export default {
    components: {
        FormularioCategoria,
        TituloPagina
    },
    data: () => ({
        formData: {
            categoria_id: "",
            categoria_nome: ""
        },
        showForm: false
    }),
    created() {
        // verifica se pode acessar componente
        if (
            Auth.getCargoUsuario() !== MASTER &&
            [DONO, GERENTE, ESPECIALISTA].indexOf(Auth.getCargoUsuario()) === -1
        ) {
            this.$router.push("/sempermissao");
        }
        let self = this;
        get("categoria/" + this.$route.params.id).then(function(response) {
            let categoria = response.data.result.data;
            self.formData.categoria_id = categoria.categoria_id;
            self.formData.categoria_nome = categoria.categoria_nome;
            self.showForm = true;
        });
    },
    methods: {
        save() {
            if (this.formData.categoria_nome === "") {
                Message.messageError("Nome é obrigatório!");
                return;
            }

            let self = this;
            put("categoria/" + this.formData.categoria_id, {
                categoria_nome: this.formData.categoria_nome
            })
                .then(function(response) {
                    Message.messageSuccess(response.data.statusMessage);
                    self.$router.push("/categorias", function() {});
                })
                .catch(function() {
                    Message.messageError(
                        "Ocorreu algum erro, tente novamente mais tarde."
                    );
                });
        },
        handleDataCategoria(e) {
            [this.formData.categoria_nome] = e;
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/categorias/Editar.vue